// COMMON
export const SET_GLOBAL_LOADING = "SET_GLOBAL_LOADING";
export const SET_GLOBAL_APP_THEME = "SET_GLOBAL_APP_THEME";
export const EMPTY_COMMON = "EMPTY_COMMON";
export const EMPTY_CATALOG = "EMPTY_CATALOG";

// AUTH
export const SAVE_COMMONTOKEN = "SAVE_COMMONTOKEN";
export const REMOVE_COMMONTOKEN = "REMOVE_COMMONTOKEN";
export const SAVE_CURRENT_USER = "SAVE_CURRENT_USER";
export const REMOVE_CURRENT_USER = "REMOVE_CURRENT_USER";
export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export const SET_TEMP_ORDER_ID = "SET_TEMP_ORDER_ID";
export const EMPTY_AUTH = "EMPTY_AUTH";

// CATALOG -
// categories
export const ADD_CATAGORIES = "ADD_CATAGORIES";

// CART
export const SET_CART_ITEMS_DATA = "SET_CART_ITEMS_DATA";
export const SET_CART_IMAGES_DATA = "SET_CART_IMAGES_DATA";
export const SET_CART_DETAILS = "SET_CART_DETAILS";
export const DELETE_CART_DATA = "DELETE_CART_DATA";
export const SET_COUPON = "SET_COUPON";
export const EMPTY_CART = "EMPTY_CART";
